/* eslint-disable-next-line import,prettier/prettier */
import {
  Home,
  NotFound,
} from '@/views';
import Renderer from '@/components/Renderer';

export default [
  {
    path:      '/',
    component: Home,
    name:      'Home',
    meta:      { title: 'Home' },
  },
  {
    path:      '/renderer',
    component: Renderer,
    name:      'Renderer',
    meta:      { title: 'Renderer' },
  },
  {
    path:      '*',
    component: NotFound,
    name:      'Error 404',
    meta:      { title: 'Page not Found' },
  },
];
